// ============================================================================
// BUNDLE VERSION CHECK — auto-evict stale localStorage on version bump
// ============================================================================
// End users don't Ctrl+Shift+R. When we deploy a new build (npm run build →
// new main.[hash].js), the HTML re-fetches the fresh bundle automatically —
// but localStorage state (MODULES_CONFIG, PERMISSIONS, cached user context)
// is carried over from the OLD build. That's how stale-context bugs sneak
// past a deploy: the code is new, the cached data isn't.
//
// This check runs BEFORE React mounts. It compares the version baked into
// this bundle (from package.json at build time) against the version stored
// in localStorage from the user's last session. On mismatch it clears
// localStorage entirely — user re-authenticates and loads a completely
// fresh context.
//
// Complement this with a web-server rule that forbids caching index.html —
// see docs/DEPLOYMENT_CACHING.md (in the react-project-template repo)
// for the nginx / IIS snippets.

import packageJson from '../../package.json';

const STORAGE_KEY = 'APP_BUNDLE_VERSION';
const CURRENT_VERSION = (packageJson as { version: string }).version;

/**
 * Compares the version baked into this bundle against the version last
 * stored in localStorage. On mismatch, clears localStorage so the app
 * loads a fresh context. Idempotent — safe to call once per page load
 * before React mounts.
 */
export function checkBundleVersion(): void {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored !== CURRENT_VERSION) {
      // eslint-disable-next-line no-console
      console.info(
        `[bundleVersionCheck] Bundle version changed ${stored} → ${CURRENT_VERSION}; clearing localStorage to evict stale state`,
      );
      localStorage.clear();
    }
    if (CURRENT_VERSION) {
      localStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
    }
  } catch {
    // localStorage disabled (privacy mode) — no-op; nothing to evict.
  }
}
